import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import * as httpClient from "../../util/httpClient";
import { DialogComponent } from "./../common/DialogComponent";
import MFAInfoDialog from "../Dialogs/MFAInfoDialog";
import { useTranslation } from "react-i18next";

type GenerateLoginMFAProps = RouteComponentProps<{}>;

const GenerateLoginMFA: React.FunctionComponent<GenerateLoginMFAProps> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const dispatch = useDispatch();
    const [state, setState] = useState({ communicationOptopn: "EMAIL", isLoading: false, type: "", preferredCommunicationMediaList: [] });
    const secureCode = useSelector((state: ApplicationState) => (state.loggedInUser && state.loggedInUser.secureCode ? state.loggedInUser.secureCode : ""));
    const [showDialog, setShowDialog] = useState(false);
    const [logoHTML, setLogoHTML] = useState("");
    const preferredCommunicationMediaList = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.communicationMethodList ? state.loggedInUser.communicationMethodList : []
    );
    let footerLogoHTML: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.footerLogoHTML
            : ""
    );
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                              .split(";")
                              .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                              .split("=")[1]
                            ? document.cookie
                                  .split(";")
                                  .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                  .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
        if (footerLogoHTML) {
            const domParser = new DOMParser();
            const parsedDoc = domParser.parseFromString(footerLogoHTML, 'text/html');
            let imgElement = parsedDoc.querySelector('img');
            if (imgElement) {
                imgElement.setAttribute('alt', 'Logo');
                footerLogoHTML = parsedDoc.documentElement.innerHTML;
                setLogoHTML(footerLogoHTML);
            }
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleCloseDialog = (): any => {
        setShowDialog(false);
    };

    const maskedField = (field: any) => {
        if (field) {
            let index = field.length - 4;
            let maskedFields = field.slice(0, index);
            return field.replace(maskedFields, "******");
        }
    };

    const handleChange = (e: any) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const getData = () => {
        if (state.type === "MFA") {
            return {
                header: tLang("generateMfa.whatMFALinkText"),
                description1: tLang("generateMfa.whatIsMFAText.description1"),
                description2: tLang("generateMfa.whatIsMFAText.description2"),
            };
        } else {
            return {
                header: tLang("generateMfa.whatIsVerificationCode"),
                description1: tLang("generateMfa.whatIsVerificationCodeText.description1"),
                description2: tLang("generateMfa.whatIsVerificationCodeText.description2"),
            };
        }
    };

    const handleClick = (type: string) => {
        setState({ ...state, type: type });
        setShowDialog(true);
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        setState({ ...state, isLoading: true });
        window.addToDataLayer({ event: "Generate Login MFA" });

        dispatch({ type: "SELECT_COMMUNICATION_METHOD", selectedMethod: state.communicationOptopn });
        let method = 0;
        if (state.communicationOptopn === "EMAIL") {
            method = 0;
        }
        if (state.communicationOptopn === "SMS") {
            method = 1;
        }
        if (state.communicationOptopn === "Call") {
            method = 3;
        }
        const requestBody = {
            NotificationMethod: method,
            SecurityCode: secureCode,
        };

        httpClient.sendRequest("POST", "web/login/send-mfa-secureCode", requestBody).then((data) => {
            if (!data["hasError"]) {
                props.history.push("/validate-MFA");
            }
            setState({ ...state, isLoading: false });
        });
    };

    return (
        <React.Fragment>
            <div id="l-page-content">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page">
                                Member Login
                            </h1>
                        </div>
                    </div>
                    <div className="row" id="content">
                        <div className="col-xs">
                            <div className={state.isLoading ? "box box-has-shadow box-xs offset-padding loading" : "box box-has-shadow box-xs offset-padding"}>
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <em className="las la-exclamation-triangle"></em>
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">{tLang("generateMfa.title")}</h2>
                                        </div>
                                    </div>
                                    <div className="box-description">
                                        <p>{tLang("generateMfa.para1")}</p>
                                        <p>{tLang("generateMfa.para2")}</p>
                                    </div>
                                </div>
                                <div className="box-content">
                                    <form id="form-member-login">
                                        <h3 className="content-sub-title">{tLang("generateMfa.howToReceiveCodeQuestion")}</h3>

                                        <div className="margin-top-s"></div>

                                        {preferredCommunicationMediaList.length > 0 &&
                                            preferredCommunicationMediaList.map((item, index) => {
                                                if (item.methodType === "EMAIL") {
                                                    return (
                                                        <div className="form-row no-margin" key={index}>
                                                            <div className="form-input">
                                                                <label className="form-radio-label">
                                                                    <input
                                                                        type="radio"
                                                                        value={item.methodType}
                                                                        onChange={(e: any) => handleChange(e)}
                                                                        id={`edit-card-1-card-category-credit-card-${index}`}
                                                                        name="communicationOptopn"
                                                                        checked={state.communicationOptopn === item.methodType}
                                                                    />
                                                                    <span className="form-radio-label-text">
                                                                        <label htmlFor={`edit-card-1-card-category-credit-card-${index}`}>
                                                                            <span className="bold">
                                                                                {tLang("generateMfa.radioLabels.email") + ": "}
                                                                            </span>
                                                                        </label>
                                                                        {item.recepientAddress}
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    );
                                                } else {
                                                    return (
                                                        <div className="form-row no-margin" key={index}>
                                                            <div className="form-input">
                                                                <label className="form-radio-label">
                                                                    <input
                                                                        type="radio"
                                                                        value={item.methodType}
                                                                        onChange={(e: any) => handleChange(e)}
                                                                        id={`edit-card-1-card-category-credit-card-${index}`}
                                                                        name="communicationOptopn"
                                                                        checked={state.communicationOptopn === item.methodType}
                                                                    />
                                                                    <span className="form-radio-label-text">
                                                                        <label htmlFor={`edit-card-1-card-category-credit-card-${index}`}>
                                                                            <span className="bold">
                                                                                {item.methodType === "SMS"
                                                                                    ? `${tLang("generateMfa.radioLabels.sms")}: `
                                                                                    : `${tLang("generateMfa.radioLabels.call")}: `}
                                                                            </span>
                                                                        </label>
                                                                        {maskedField(item.recepientAddress)}
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            })}

                                        <div className="margin-bottom-s"></div>

                                        <div className="form-row">
                                            <button type="submit" className="btn-default btn-primary btn-min-width" onClick={handleSubmit}>
                                                <span className="btn-text">{tLang("generateMfa.submitButtonText")}</span>
                                            </button>
                                        </div>

                                        <div className="margin-vertical-l"></div>

                                        <p>
                                            <a
                                                href="#"
                                                className="default_link"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleClick("MFA");
                                                    window.addToDataLayer({ event: "What is Multi-Factor Authentication?" });
                                                }}
                                            >
                                                {tLang("generateMfa.whatMFALinkText")}
                                            </a>
                                        </p>
                                        <p>
                                            <a
                                                href="#"
                                                className="default_link"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleClick("TemporaryCode");
                                                    window.addToDataLayer({ event: "What is a Temporary Verification Code?" });
                                                }}
                                            >
                                                {tLang("generateMfa.whatIsVerificationCode")}
                                            </a>
                                        </p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="logo-container" dangerouslySetInnerHTML={{ __html: logoHTML }}></div>
            </div>
            {showDialog && (
                <div className="center-dialog">
                    <DialogComponent dialogId="MFA-INFO-dialog" title="Medical fraud protection" closeDialog={handleCloseDialog}>
                        <MFAInfoDialog dialogData={getData()}></MFAInfoDialog>
                    </DialogComponent>
                </div>
            )}
        </React.Fragment>
    );
};

export default GenerateLoginMFA;
